










import Vue from 'vue'
import Component from 'vue-class-component'
import ProjectLearning from '@/business/project/components/project-learning.vue'
import { Prop } from 'vue-property-decorator'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
@Component({
  components: { ProjectLearning },
})
export default class ProjectLearnings extends Vue {
  @Prop({
    type: Object,
  })
  public readonly project!: ProjectViewModel
}
